import { getDynamicCalltrackingSiteBlockId } from '../../selectors/getDynamicCalltrackingSiteBlockId';
import { virtualTourKeySelector } from '../../selectors/newObject/getTour';
import { showSuburbanBuildingsBanners } from '../../selectors/showSuburbanBuildingsBanners';
import { IThunkActionCreator } from '../../store';
import { setEbcInfo } from '../../store/ebc';
import { setTrackingData } from '../../store/tracking';
import { TBinaryValue } from '../../types';
import { createEbcInfo } from '../../utils/tracking/createEbcInfo';
import { createPageTrackingData } from '../../utils/tracking/createPageTrackingData';
import { createUserTrackingData } from '../../utils/tracking/createUserTrackingData';
import { getBookedFromDeveloper } from '../../utils/tracking/getBookedFromDeveloper';
import { getCplPageExtra } from '../../utils/tracking/getCplPageExtra';
import { getPriceExtra } from '../../utils/tracking/getPriceExtra';

export const prepareEbcAction = (): IThunkActionCreator => {
  return (dispatch, getState) => {
    const state = getState();

    const {
      abGroup,
      offerData: { offer, user, agent, breadcrumbs },
    } = state;

    const siteBlockId = getDynamicCalltrackingSiteBlockId(state);
    const priceExtra = getPriceExtra(state);
    const extraCpl = getCplPageExtra(offer, siteBlockId);
    const has3dTour = Boolean(virtualTourKeySelector(state));
    const breadCrumbs = breadcrumbs ? breadcrumbs.map(bcInfo => bcInfo.title) : [];
    const showSuburbanAdfoxBlock = showSuburbanBuildingsBanners(state);
    const isBookedFromDeveloper = getBookedFromDeveloper(state);

    const extra = {
      ...extraCpl,
      ...priceExtra,
      is_booked: isBookedFromDeveloper,
      category: offer.category,
      coworkingOfferType: offer.coworkingOfferType || undefined,
      adfox: { status: Number(showSuburbanAdfoxBlock) as TBinaryValue },
    };

    if (has3dTour) {
      extra['3dtour_enabled'] = 1;
    }

    const pageTrackingData = createPageTrackingData({ agent, offer, breadCrumbs, extra });
    const userTrackingData = createUserTrackingData(abGroup, user);
    const ebcInfo = createEbcInfo({ abGroup, breadCrumbs, offerID: offer.id, user });

    dispatch(setTrackingData(userTrackingData, pageTrackingData));
    dispatch(setEbcInfo(ebcInfo));
  };
};
